document.addEventListener('DOMContentLoaded', initAffiliatePage);

function initAffiliatePage() {
  const page = document.querySelector('[data-affiliate-page]');
  if (!page) return;

  initAffiliateFaq(page);
  initAffiliateForm(page);
}

function initAffiliateFaq(page) {
  const items = page.querySelectorAll('[data-affiliate-faq-item]');

  items.forEach((item) => {
    const btn = item.querySelector('[data-affiliate-faq-toggle]');
    const panel = item.querySelector('[data-affiliate-faq-panel]');
    if (!btn || !panel) return;

    btn.addEventListener('click', () => {
      const isOpen = btn.classList.contains('is-open');

      items.forEach((other) => {
        const otherBtn = other.querySelector('[data-affiliate-faq-toggle]');
        const otherPanel = other.querySelector('[data-affiliate-faq-panel]');
        if (!otherBtn || !otherPanel) return;
        otherBtn.classList.remove('is-open');
        otherBtn.setAttribute('aria-expanded', 'false');
        otherPanel.hidden = true;
      });

      if (!isOpen) {
        btn.classList.add('is-open');
        btn.setAttribute('aria-expanded', 'true');
        panel.hidden = false;
      }
    });
  });
}

function initAffiliateForm(page) {
  const form = page.querySelector('#AffiliateForm');
  if (!form || form.dataset.submitted === 'true') return;

  const bodyField = form.querySelector('[data-affiliate-body]');
  const errorEl = form.querySelector('[data-affiliate-error]');
  const fields = {
    name: form.querySelector('[data-affiliate-name]'),
    email: form.querySelector('[data-affiliate-email]'),
    password: form.querySelector('[data-affiliate-password]'),
    platform: form.querySelector('[data-affiliate-platform]'),
    audience: form.querySelector('[data-affiliate-audience]'),
    message: form.querySelector('[data-affiliate-message]'),
    paypal: form.querySelector('[data-affiliate-paypal]')
  };

  form.addEventListener('submit', (event) => {
    const name = fields.name?.value.trim() || '';
    const email = fields.email?.value.trim() || '';
    const password = fields.password?.value || '';
    const platform = fields.platform?.value.trim() || '';

    if (!name || !email || !password || !platform) {
      event.preventDefault();
      showAffiliateError(errorEl, 'Please fill in name, email, password, and platform.');
      return;
    }

    if (password.length < 8) {
      event.preventDefault();
      showAffiliateError(errorEl, 'Password must be at least 8 characters.');
      return;
    }

    if (bodyField) {
      const lines = [
        'Affiliate Application',
        '',
        `Full Name: ${name}`,
        `Email: ${email}`,
        `Platform / Website: ${platform}`,
        `Audience Size: ${fields.audience?.value || 'Not specified'}`,
        `PayPal Email: ${fields.paypal?.value.trim() || 'Not provided'}`,
        '',
        'About Audience:',
        fields.message?.value.trim() || 'Not provided',
        '',
        `Password: ${password}`
      ];
      bodyField.value = lines.join('\n');
    }

    hideAffiliateError(errorEl);
  });
}

function showAffiliateError(el, message) {
  if (!el) return;
  el.textContent = message;
  el.hidden = false;
}

function hideAffiliateError(el) {
  if (!el) return;
  el.hidden = true;
  el.textContent = '';
}
